function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './NewsCarouselGlobal.css';
import React, { useEffect, useState, useRef } from 'react';
import throttle from 'lodash/throttle';
import { canUseDOM, get, getTags } from '../../../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../../../atoms/ComponentsWrapper';
import CarouselProvider from '../../../atoms/CarouselProvider/CarouselProvider';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../../../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../../utils/tealium';
import getListing, { isTagsRule, loadCategoryAlgoliaResults } from '../../../../utils/getListing';
import { convertToAnalyticObject } from '../../../../utils/analytics';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { algoliaScoredCondition } from '../../../../utils/algoliaScoredCondition';
import NewsCarouselItemGlobal from './NewsCarouselItemGlobal';
export const NewsCarouselGlobal = _ref => {
  let {
    fields,
    params,
    route
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const {
    isPersonalised
  } = sitecoreContext;
  const carouselWrapperRef = useRef(null);
  const [isVdsite, setIsVdsite] = useState(true);
  const [isHidden, setIsHidden] = React.useState(undefined);
  const [titleHeight, setTitleHeight] = useState(0);
  const [descriptionHeight, setDescriptionHeight] = useState(0);
  const [dateHeight, setDateHeight] = useState(0);
  const [btnHeight, setBtnHeight] = useState(0);
  const [searchResults, setSearchResults] = useState([]);
  const variant = get(params, 'variant');
  const indexName = get(params, 'SearchIndex');
  const searchCount = Number(get(params, 'SearchCount'));
  const allValues = [];
  const title = get(fields, 'data.datasource.title.jss');
  const description = get(fields, 'data.datasource.description.jss');
  const ctaLink = get(fields, 'data.datasource.ctaLink.jss.value.href');
  const ctaLabel = get(fields, 'data.datasource.ctaLabel.jss.value', 'See more');
  const ctaLeftIcon = get(fields, 'data.datasource.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.datasource.ctaRightIcon.targetItem.svg.jss.value');
  const intents = get(fields, 'data.datasource.intents');
  const intentsLength = get(intents, 'targetItems.length');
  const contextItem = get(fields, 'data.contextItem');
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  const itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  const considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  const tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  const currentPageID = get(route, 'itemId', '').split('-').join('');
  const isTagsRuleUsed = isTagsRule(tagsRule);
  let dummyId;
  if (process.env.STORYBOOK_MODE) {
    dummyId = '6a1d9e4935ad4273804e7cbc56f0d62b';
  }
  const formatTagsRuleToFilters = function () {
    let withType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let facetsFilters = [withType && ['News']];
    if (isTagsRuleUsed) {
      let parsedTR = JSON.parse(tagsRule);
      if (parsedTR.length) {
        parsedTR.forEach(rule => {
          facetsFilters.push(rule);
        });
      }
    }
    return facetsFilters;
  };
  const {
    personalizedList,
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: searchResults,
    conditions: [algoliaScoredCondition(allValues)]
  });
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(() => {
    if (isPersonalised && intentsLength) {
      (async () => {
        const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, 'News', searchCount, isTagsRuleUsed ? formatTagsRuleToFilters(false) : considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags], [''], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
        // setResults(hits);
        setSearchResults(hits);
        refreshTracking();
      })();
    } else {
      let filters = currentPageID ? `NOT objectID:${currentPageID}` : '';
      let itemFilter = {
        hitsPerPage: searchCount,
        facetFilters: isTagsRuleUsed ? formatTagsRuleToFilters(true) : [['News'], considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags]],
        // filters: currentPageID ? `NOT objectID:${currentPageID}` : '',
        filters
      };
      let results = [];
      let hiddenResults = '';
      getListing(indexName, itemFilter, algoliaSettings).then(hits => {
        results.push(hits && hits.hits);
        results[0].map(result => {
          hiddenResults += ` AND NOT objectID:${result.objectID}`;
        });
        if (hits && hits.hits.length !== searchCount) {
          let itemFilter = {
            hitsPerPage: searchCount - hits.hits.length,
            facetFilters: [['News']],
            filters: currentPageID ? ` (NOT objectID:${currentPageID} ${hiddenResults})` : ` (NOT objectID:${dummyId} ${hiddenResults})`
          };
          getListing(indexName, itemFilter, algoliaSettings).then(hits => {
            results.push(hits && hits.hits);
            let finalResults = results[0].concat(results[1]);
            finalResults.length ? setIsHidden(false) : setIsHidden(true);
            setSearchResults(finalResults);
          });
        } else {
          results[0].length ? setIsHidden(false) : setIsHidden(true);
          results[0] && setSearchResults(results[0]);
        }
      });
    }
  }, [isPersonalised]);
  let countHeights;
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (carouselWrapperRef.current) {
        const titleHeights = Array.from(carouselWrapperRef.current.querySelectorAll(`.title`)).map(item => {
          return item.offsetHeight;
        });
        const descriptionHeights = Array.from(carouselWrapperRef.current.querySelectorAll(`.description`)).map(item => {
          return item.offsetHeight;
        });
        const dateHeight = Array.from(carouselWrapperRef.current.querySelectorAll(`.date-wrapper`)).map(item => {
          return item.offsetHeight;
        });
        const btnHeight = Array.from(carouselWrapperRef.current.querySelectorAll(`.btn-tertiary--carousel--wrapper`)).map(item => {
          return item.offsetHeight;
        });
        setTitleHeight(Math.max(...titleHeights));
        setDescriptionHeight(Math.max(...descriptionHeights));
        setDateHeight(Math.max(...dateHeight));
        setBtnHeight(Math.max(...btnHeight));
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize, searchResults]);
  if (!fields) {
    console.info('NewsCarouselGlobal component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[NewsCarouselGlobal component is empty: please provide data source]");
    }
    return null;
  }
  if (searchResults.length < 1) return null;
  const showCarousel = searchResults.length > 3;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderTileItems = () => {
    return searchResults.map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      className: variant === 'Default' || variant === 'WithImage' ? '' : `${variant === 'VerticalList' ? 'col-lg-12' : 'col-lg-6'} grid-item-col`,
      key: `$article-carousel-tile-${index}`
    }, /*#__PURE__*/React.createElement(NewsCarouselItemGlobal, _extends({}, item, {
      variant: variant,
      showCarousel: showCarousel,
      eventsAnalytics: eventsAnalytics,
      params: params
    }))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isHidden: true,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", null, showCarousel && variant !== 'Grid' && variant !== 'VerticalList' ? /*#__PURE__*/React.createElement("div", {
    ref: carouselWrapperRef,
    style: {
      '--titles-height': titleHeight,
      '--descriptions-height': descriptionHeight,
      '--date-heights': dateHeight,
      '--btn-heights': btnHeight
    }
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, title || description ? /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: "carouselTitleDescriptionWrapper",
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, title ? /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "carousel-title",
      field: title
    }) : null, description ? /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "carousel-description",
      field: description
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group-wrapper"
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['optionsPreviousClickAnalytics'], params)), true, false), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['optionsNextClickAnalytics'], params)), true, false))), renderCarousel(renderTileItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: 3
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1280
          },
          items: 2
        },
        tablet_landscape: {
          breakpoint: {
            max: 1280,
            min: 767
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement(React.Fragment, null, renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['optionsBubblesClickAnalytics'], params))), ctaLink && /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: `News-carousel-button--under-dots btn btn-secondary`,
      href: ctaLink,
      title: `${ctaLabel} ${title}`,
      linktype: '',
      linksTarget: '',
      ctaLeftIcon: ctaLeftIcon,
      ctaRightIcon: ctaRightIcon,
      onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [title.value])
    }, ctaLabel))));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, title || description ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "carouselTitleDescriptionWrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, title ? /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "carousel-title",
    field: title
  }) : null, description ? /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "carousel-description",
    field: description
  }) : null) : null, /*#__PURE__*/React.createElement("div", {
    ref: carouselWrapperRef,
    style: {
      '--titles-height': titleHeight,
      '--descriptions-height': descriptionHeight
    },
    className: "NewsItems-row row"
  }, renderTileItems()), ctaLink && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: `News-carousel-button btn btn-secondary`,
    href: ctaLink,
    title: `${ctaLabel} ${title}`,
    linktype: '',
    linksTarget: '',
    ctaLeftIcon: ctaLeftIcon,
    ctaRightIcon: ctaRightIcon,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [title.value])
  }, ctaLabel)))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    isHidden,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, ' ', !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`
  }, children) : null, ' ');
};
const commonStyles = "cltyqwe";
const ltrStyles = "l16uk91a";
const rtlStyles = "rgf1rjm";
export default NewsCarouselGlobal;